import { CallRecord, Caller } from "../types/CallHistoryRes";

/** Pick display peer for a call-history row (never current user for 1:1). */
export function resolveCallHistoryPeer(
  record: CallRecord,
  myUserId: number | string | undefined | null,
): Caller | null {
  const me = myUserId != null ? Number(myUserId) : NaN;

  const asUser = (raw: any): Caller | null => {
    if (!raw) return null;
    const list = Array.isArray(raw) ? raw : [raw];
    for (const item of list) {
      if (!item || item.user_id == null) continue;
      const id = Number(item.user_id);
      if (Number.isFinite(me) && id === me) continue;
      return {
        user_id: id,
        user_name: item.user_name || item.full_name || "",
        profile_pic: item.profile_pic || "",
        full_name: item.full_name,
      } as Caller;
    }
    return null;
  };

  const fromExplicit =
    asUser((record as any).other_user) ||
    asUser((record as any).peerUserData) ||
    asUser((record as any).peerUser) ||
    asUser(record.peer_user) ||
    asUser((record.Chat as any)?.PeerUserData) ||
    asUser((record.Chat as any)?.peerUserData) ||
    asUser((record.Chat as any)?.peer_user);

  if (fromExplicit) return fromExplicit;

  const caller = record.Calls?.[0]?.caller;
  if (caller?.user_id != null && Number(caller.user_id) !== me) {
    return caller;
  }
  return null;
}

/** Missed only when someone else called us; our unanswered = outgoing. */
export function resolveCallHistoryDirection(
  record: CallRecord,
  myUserId: number | string | undefined | null,
): "outgoing" | "incoming" | "missed" {
  const wired = String((record as any).call_direction || "").toLowerCase();
  if (wired === "outgoing" || wired === "incoming" || wired === "missed") {
    return wired as "outgoing" | "incoming" | "missed";
  }
  const me = myUserId != null ? Number(myUserId) : NaN;
  const call = record.Calls?.[0];
  const callerId = Number(call?.caller?.user_id);
  const mine = Number.isFinite(me) && callerId === me;
  const status = String(call?.call_status || "").toLowerCase();
  if (status === "missed") return mine ? "outgoing" : "missed";
  return mine ? "outgoing" : "incoming";
}
